/*
  Favoritos (wishlist)
  ------------------------------------------------------------
  Estado por dispositivo, en localStorage: un array plano de handles de producto.
  Ese formato es el original y se mantiene a proposito — cambiarlo invalidaria lo
  que los visitantes ya tengan guardado.

  El modulo se expone como `window.IGWishlist` porque la grilla de
  /pages/favoritos (`section-favorites-grid.js`) necesita dos cosas que una IIFE
  cerrada no puede dar:

  1. `sync(root)` — las cards inyectadas por fetch no pasan por ningun evento del
     tema, asi que sus bookmarks quedarian apagados hasta un reload.
  2. el evento `ig:wishlist:change` — para sacar una card del DOM en el momento
     en que se la desmarca, sin recargar.

  Ligarlo a la cuenta del cliente no es posible desde un tema: el storefront no
  puede escribir metafields de customer. Ver DECISIONS.md.
*/
(function () {
  var KEY = 'ig_wishlist';
  var EVENT = 'ig:wishlist:change';
  var SELECTOR = '.ig-wishlist-btn';

  function read() {
    try {
      var raw = localStorage.getItem(KEY);
      var parsed = raw ? JSON.parse(raw) : [];
      if (!Array.isArray(parsed)) return [];
      // Defensivo: una version vieja o un tercero podrian haber dejado basura.
      return parsed.filter(function (handle) {
        return typeof handle === 'string' && handle.length > 0;
      });
    } catch (e) {
      return [];
    }
  }

  function write(list) {
    try {
      localStorage.setItem(KEY, JSON.stringify(list));
    } catch (e) {}
  }

  function has(handle) {
    return read().indexOf(handle) > -1;
  }

  /* `root` acota el re-sync a un subarbol recien inyectado. Sin argumento
     recorre el documento entero, que es lo que hace falta en load. */
  function sync(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var list = read();
    scope.querySelectorAll(SELECTOR).forEach(function (btn) {
      var handle = btn.getAttribute('data-product-handle');
      var on = !!handle && list.indexOf(handle) > -1;
      btn.setAttribute('data-active', on ? 'true' : 'false');
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    });
  }

  function announce(handle, added) {
    document.dispatchEvent(
      new CustomEvent(EVENT, {
        detail: { list: read(), handle: handle || null, added: added }
      })
    );
  }

  function add(handle) {
    if (!handle) return false;
    var list = read();
    if (list.indexOf(handle) > -1) return false;
    list.push(handle);
    write(list);
    sync();
    announce(handle, true);
    return true;
  }

  function remove(handle) {
    if (!handle) return false;
    var list = read();
    var idx = list.indexOf(handle);
    if (idx === -1) return false;
    list.splice(idx, 1);
    write(list);
    sync();
    announce(handle, false);
    return true;
  }

  function toggle(handle) {
    return has(handle) ? (remove(handle), false) : (add(handle), true);
  }

  function clear() {
    write([]);
    sync();
    announce(null, false);
  }

  /* La card entera es un link, asi que el click tiene que morir aca. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest(SELECTOR);
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    var handle = btn.getAttribute('data-product-handle');
    if (!handle) return;
    toggle(handle);
  });

  /* Otra pestaña movio la lista. `storage` no dispara en la pestaña que escribio,
     asi que no hay riesgo de loop con `announce`. */
  window.addEventListener('storage', function (e) {
    if (e.key && e.key !== KEY) return;
    sync();
    announce(null, false);
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      sync();
    });
  } else {
    sync();
  }

  document.addEventListener('shopify:section:load', function (e) {
    sync(e && e.target);
  });

  window.IGWishlist = {
    key: KEY,
    event: EVENT,
    read: read,
    has: has,
    add: add,
    remove: remove,
    toggle: toggle,
    clear: clear,
    sync: sync
  };
})();
